"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Linkedin, Twitter } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-row gap-6">
        {menuItems.map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-[var(--duration-medium)] underline-offset-4 hover:underline">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer ref={ref} className={`w-full py-6 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="glass-effect border-t border-muted/40 backdrop-blur-md bg-background/80">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 py-4">
            <div className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} NorthStar Advisory. Tous droits réservés.
            </div>

            <div className="flex items-center justify-center">
              <MenuProvider menu_id="4">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            
          </div>
        </div>
      </div>
    </footer>;
}